(function () {
  'use strict';

  window.onload = init;

  function init() {

    let questions = document.querySelectorAll('ul.accordion > li > a');
    let answers = document.querySelectorAll('ul.accordion > li > div');

    if (questions !== null && answers !== null) {

      // Listen for hash change
      window.addEventListener('hashchange', (event) => {
        event.preventDefault();
        reset();
        let hash = getHash();
        if (hash) openAnswer(hash);
      }, false);

      // First, close all answers
      reset();

      let hash = getHash();
      if (hash) openAnswer(hash);


      function getHash() {
        const hash = window.location.hash.split('#')[1];
        return (hash !== "" || typeof hash != "undefined") ? hash : false;
      }

      // Open accordion
      function openAnswer(qhash) {
        let element = document.getElementById(qhash);
        let answer = element.nextElementSibling;

        element.classList.add("font-bold");
        answer.classList.replace('max-h-0', 'max-h-auto');
        answer.classList.replace('opacity-0', 'opacity-1');
        answer.classList.replace('mb-0', 'mb-4');
      }

      // Reset open accordions
      function reset() {
        questions.forEach((question) => {
          question.classList.remove('font-bold');
        });

        answers.forEach((answer) => {
          answer.classList.replace('max-h-auto', 'max-h-0');
          answer.classList.replace('opacity-1', 'opacity-0');
          answer.classList.replace('mb-4', 'mb-0');
        });
      }
    }
  }
})();